module.exports = __webpack_public_path__ + "static/media/stalk.19f350c9.png";